import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { Observable } from "rxjs";

import { environment } from "@env/environment";
import { UserExtract } from "@model/admin/user-extract";
import { Paginate } from "@model/admin/paginate";
import { NumberSymbol } from "@angular/common";

export interface Guest {
  email: string;
}

@Injectable({
  providedIn: "root",
})
export class UsersService {
  public PROFILE_CODS = [
    { id: "student", description: "Estudante" },
    { id: "teacher", description: "Professor" },
  ];

  constructor(private http: HttpClient) {}

  getGuests(param: string = ""): Observable<Guest[]> {
    return this.http.get<Guest[]>(
      `${environment.base_url}/users/find_email?param=${param}`
    );
  }

  userAlreadyExists(email: string): Observable<any> {
    return this.http.get(
      `${environment.base_url}/users/already_exists?param=${email}`
    );
  }

  getUserAccess(userId: number) {
    return this.http.get(`${environment.base_url}/users/${userId}/access/count`);
  }

  updateResearchProfileType(
    userId: number,
    profileType: string
  ): Observable<any> {
    return this.http.put<any>(
      `${environment.base_url}/users/${userId}/update_profile_type`,
      { profile_type: profileType }
    );
  }

  updateWordsCount(userId: number, words: number): Observable<any> {
    return this.http.put<any>(
      `${environment.base_url}/users/${userId}/update_words_count`,
      { words: words }
    );
  }

  getWordsCount(userId: number): Observable<any> {
    return this.http.get<any>(
      `${environment.base_url}/users/${userId}/get_words_count`
    );
  }

  getInvitationCode(userId: number): Observable<any> {
    return this.http.get<any>(
      `${environment.base_url}/users/${userId}/get_invitation_code`
    );
  }

  getExtract(
    userId: number,
    per_page: number = 10,
    page: number = 1
  ): Observable<Paginate<UserExtract>> {
    return this.http.get<Paginate<UserExtract>>(
      `${environment.base_url}/users/${userId}/extract_admin?page=${page}&per_page=${per_page}`
    );
  }

  pixRequest(formData: any): Observable<any> {
    return this.http.post<any>(
      `${environment.base_url}/users/pix_request`,
      formData
    );
  }

  updateAttending(userId: number, attending: string): Observable<any> {
    return this.http.put<any>(
      `${environment.base_url}/users/${userId}/update_attending`,
      { attending: attending }
    );
  }

  getUserId(): Observable<any> {
    return this.http.get<any>(
      `${environment.base_url}/users/get_user_id`
    );
  }

  getUserWordsById(userId: number): Observable<any> {
    return this.http.get<any>(
      `${environment.base_url}/users/${userId}/get_user_words_count`
    );
  }
}
